import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "C:/Users/Simon/Documents/simonrose121.github.io/src/templates/projects-layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...props} components={components} mdxType="MDXLayout">
    <p>{`Pirate Plunder is a novel educational programming game that introduces repeats, custom blocks and clones in a game-based Scratch-like setting. The aim is to teach players to use these blocks to reduce block duplication through block reuse`}</p>
    <p>{`It is written using the MEAN stack (MongoDB, AngularJS, Express.js and Node.js) with Angular 5 and TypeScript. It uses Google Blockly for the block-based programming environment and PixiJS for the grid.`}</p>
    <p>{`The game has successful in several studies to measure its effectiveness with children age 10 and 11.`}</p>
    <p>{`Conference papers on Pirate Plunder have been presented at the`}
      {" "}
      {` `}
      <a href="http://shura.shu.ac.uk/21715/7/Rose%20Pirate%20Plunder%20Game%20Based%20Computational%20Thinking%20Using%20Scratch%20Blocks.pdf" target="_blank">{` 12th European Conference for Game Based Learning`}
        {" "}
        {` `}</a>
      {` and the`}
      {" "}
      {` `}
      <a href="https://dl.acm.org/citation.cfm?id=3312871" target="_blank">{` CHI 2019 Conference on Human Factors in Computing Systems `}</a>
      {` , as well as a journal article published in the`}
      {" "}
      {` `}
      <a href="https://journals.sagepub.com/doi/10.1177/0735633120932871" target="_blank">{` Journal of Educational Computing Research`}</a>
      {`.`}</p>
    <p>{`You can play Pirate Plunder`}
      {" "}
      {` `}
      <a href="https://pirateplunder.simon-rose.co.uk/" target="_blank">{` here`}</a>
      {`. Please use Google Chrome it may not work correctly on other browsers.`}</p>

  </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      